<template>
    <div class="horizontal-divider-settings">
        <div class="device-selector--mini">
            
            <i class="fas fa-desktop active" data-device="desktopSettings" v-b-tooltip.hover.top title="Desktop" @click="switchDevice"></i>
            <i class="fas fa-tablet-alt" data-device="tabletSettings" v-b-tooltip.hover.top title="Tablet" @click="switchDevice"></i>
            <i class="fas fa-mobile-alt" data-device="mobileSettings" v-b-tooltip.hover.top title="Phone" @click="switchDevice"></i>

        </div>

        <div class="settings-group-title">
            <h6>styles</h6>
        </div>

        <!-- divider type -->
        <div class="setting" v-if="clientPro=='PRO' && desktopSettings">
            <b-form-group label="Divider type:">

                <b-form-select @change="setDividerType" v-model="settingsFromWeebly.settings.dividerType" size="sm">

                    <option value="simpleDivider">Simple</option>

                    <option value="iconLeftDivider">With left icon</option>

                    <option value="iconCenterDivider">With centered icon</option>

                    <option value="iconRightDivider">With right icon</option>

                </b-form-select>

            </b-form-group>
        </div>

        <!-- divider type free-->
        <div class="setting pro-setting" v-if="clientPro!=='PRO' && desktopSettings" v-b-tooltip.hover.top title="PRO feature" v-b-modal="'upgrades-modal'">
            <b-form-group label="Divider type:">

                <b-form-select size="sm">

                    <option value="simpleDivider">Simple</option>

                    <option value="iconLeftDivider">With left icon</option>

                    <option value="iconCenterDivider">With centered icon</option>

                    <option value="iconRightDivider">With right icon</option>

                </b-form-select>

            </b-form-group>
        </div>

        <!-- background -->
        <div class="setting" v-show="desktopSettings">
            <Mycolorpicker elementRef="dividerColor" theColorPicker="allpickers" colorPickerName="Divider color:" />
        </div>

        <div class="settings-group-title">
            <h6>dimensions</h6>
        </div>
        
        <!-- width desktop -->
        <div class="setting" v-show="desktopSettings">
            <b-form-group label="Divider width:" label-for="divider-width-input">
                
                <b-input-group append="px" size="sm">
                    <b-form-input id="divider-width-input" type="number" v-model="settingsFromWeebly.settings.dividerWidth" min="5" />
                </b-input-group>

            </b-form-group>
        </div>

        <!-- width tablet -->
        <div class="setting" v-show="tabletSettings">
            <b-form-group label="Divider width:" label-for="divider-widthtablet-input">
                
                <b-input-group append="px" size="sm">
                    <b-form-input id="divider-widthtablet-input" type="number" v-model="settingsFromWeebly.settings.dividerWidthTablet" min="5" />
                </b-input-group>

            </b-form-group>
        </div>

        <!-- width phone -->
        <div class="setting" v-show="mobileSettings">
            <b-form-group label="Divider width:" label-for="divider-widthphone-input">
                
                <b-input-group append="px" size="sm">
                    <b-form-input id="divider-widthphone-input" type="number" v-model="settingsFromWeebly.settings.dividerWidthPhone" min="5" />
                </b-input-group>

            </b-form-group>
        </div>

        <!-- height -->
        <div class="setting" v-show="desktopSettings">
            <b-form-group label="Divider height:" label-for="divider-height-input">
                
                <b-input-group append="px" size="sm">
                    <b-form-input id="divider-height-input" type="number" v-model="settingsFromWeebly.settings.dividerHeight" min="1" />
                </b-input-group>

            </b-form-group>
        </div>

        <!-- margin top -->
        <div class="setting" v-show="desktopSettings">
            <b-form-group label="Margin above divider:" label-for="divider-margintop-input">
                
                <b-input-group append="px" size="sm">
                    <b-form-input id="divider-margintop-input" type="number" v-model="settingsFromWeebly.settings.dividerMarginTop" min="0" />
                </b-input-group>

            </b-form-group>
        </div>

        <!-- margin bottom -->
        <div class="setting" v-show="desktopSettings">
            <b-form-group label="Margin under divider:" label-for="divider-marginbottom-input">
                
                <b-input-group append="px" size="sm">
                    <b-form-input id="divider-marginbottom-input" type="number" v-model="settingsFromWeebly.settings.dividerMarginBottom" min="0" />
                </b-input-group>

            </b-form-group>
        </div>

        <!-- alignment -->
        <!-- align divider DESKTOP -->
        <div class="setting" v-show="desktopSettings">
            <label for="">Divider align:</label>
            <b-form-radio-group buttons class="alignment-radios" size="md" v-model="settingsFromWeebly.settings.dividerAlign">
                <b-form-radio value="left"  name="desktop-divider-aligment"><i class="fas fa-align-left"></i></b-form-radio>
                <b-form-radio value="center"  name="desktop-divider-aligment"><i class="fas fa-align-center"></i></b-form-radio>
                <b-form-radio value="right"  name="desktop-divider-aligment"><i class="fas fa-align-right"></i></b-form-radio>
            </b-form-radio-group>
        </div>

        <!-- align divider TABLET -->
        <div class="setting" v-show="tabletSettings">
            <label for="">Divider align:</label>
            <b-form-radio-group buttons class="alignment-radios" size="md" v-model="settingsFromWeebly.settings.dividerAlignTablet">
                <b-form-radio value="left"  name="tablet-divider-aligment"><i class="fas fa-align-left"></i></b-form-radio>
                <b-form-radio value="center"  name="tablet-divider-aligment"><i class="fas fa-align-center"></i></b-form-radio>
                <b-form-radio value="right"  name="tablet-divider-aligment"><i class="fas fa-align-right"></i></b-form-radio>
            </b-form-radio-group>
        </div>

        <!-- align divider PHONE -->
        <div class="setting" v-show="mobileSettings">
            <label for="">Divider align:</label>
            <b-form-radio-group buttons class="alignment-radios" size="md" v-model="settingsFromWeebly.settings.dividerAlignPhone">
                <b-form-radio value="left"  name="phone-divider-aligment"><i class="fas fa-align-left"></i></b-form-radio>
                <b-form-radio value="center"  name="phone-divider-aligment"><i class="fas fa-align-center"></i></b-form-radio>
                <b-form-radio value="right"  name="phone-divider-aligment"><i class="fas fa-align-right"></i></b-form-radio>
            </b-form-radio-group>
        </div>

        <div class="settings-group-title">
            <h6>icon styles</h6>
        </div>

        <!-- select icon -->
        <div class="setting" v-show="desktopSettings" v-if="settingsFromWeebly.settings.dividerTypeObj.iconLeftDivider || settingsFromWeebly.settings.dividerTypeObj.iconRightDivider || settingsFromWeebly.settings.dividerTypeObj.iconCenterDivider">
            <MyIconPicker :setActiveIcon="settingsFromWeebly.settings.iconClass" asToggleBox="true" />
        </div>
        
        <!-- icon color -->
        <div class="setting" v-show="desktopSettings" v-if="settingsFromWeebly.settings.dividerTypeObj.iconLeftDivider || settingsFromWeebly.settings.dividerTypeObj.iconRightDivider || settingsFromWeebly.settings.dividerTypeObj.iconCenterDivider">
            <Mycolorpicker elementRef="iconColor" theColorPicker="allpickers" colorPickerName="Icon color:"  />
        </div>

        <!--  icon size desktop -->
        <div class="setting" v-show="desktopSettings" v-if="settingsFromWeebly.settings.dividerTypeObj.iconLeftDivider || settingsFromWeebly.settings.dividerTypeObj.iconRightDivider || settingsFromWeebly.settings.dividerTypeObj.iconCenterDivider">
            <b-form-group label="Icon size:" label-for="divider-icon-size">
                
                <b-input-group append="px" size="sm">
                    <b-form-input id="divider-icon-size" type="number" v-model="settingsFromWeebly.settings.iconSize" min="5" />
                </b-input-group>

            </b-form-group>
        </div>

        <!--  icon size tablet -->
        <div class="setting" v-show="tabletSettings" v-if="settingsFromWeebly.settings.dividerTypeObj.iconLeftDivider || settingsFromWeebly.settings.dividerTypeObj.iconRightDivider || settingsFromWeebly.settings.dividerTypeObj.iconCenterDivider">
            <b-form-group label="Icon size:" label-for="divider-icon-size-tablet">
                
                <b-input-group append="px" size="sm">
                    <b-form-input id="divider-icon-size-tablet" type="number" v-model="settingsFromWeebly.settings.iconSizeTablet" min="5" />
                </b-input-group>

            </b-form-group>
        </div>

        <!--  icon size phone -->
        <div class="setting" v-show="mobileSettings" v-if="settingsFromWeebly.settings.dividerTypeObj.iconLeftDivider || settingsFromWeebly.settings.dividerTypeObj.iconRightDivider || settingsFromWeebly.settings.dividerTypeObj.iconCenterDivider">
            <b-form-group label="Icon size:" label-for="divider-icon-size-phone">
                
                <b-input-group append="px" size="sm">
                    <b-form-input id="divider-icon-size-phone" type="number" v-model="settingsFromWeebly.settings.iconSizePhone" min="5" />
                </b-input-group>

            </b-form-group>
        </div>
        
        
    </div>
</template>

<script>

import Mycolorpicker from './Mycolorpicker'
import MyIconPicker from '../elementSettings/Iconpicker'

export default {
    name: 'HorizontalDividerSettings',

    data(){
        return {
            // for color picker
            colors: '#fff',

            // settings for devices that need to be shown
            desktopSettings: true,
            tabletSettings: false,
            mobileSettings: false,
        }
    } ,

    computed:{
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },
        clientPro() {
            return this.$store.state.clientInfo.clientAccount
        }
    },

    components: {
        Mycolorpicker,
        MyIconPicker
    },

    mounted() {
        console.log(this.$store.state.weeblySettings.settings)
    },
    methods: {
        
        // divider type
        setDividerType() {
            // set all divider types to false
            for (var key in this.$store.state.weeblySettings.settings.dividerTypeObj) {
                if (this.$store.state.weeblySettings.settings.dividerTypeObj.hasOwnProperty(key)) {
                    console.log(key + " -> " + this.$store.state.weeblySettings.settings.dividerTypeObj[key]);
                    this.$store.state.weeblySettings.settings.dividerTypeObj[key] = false
                }
            }

            // set correct divider type to true
            this.$store.state.weeblySettings.settings.dividerTypeObj[event.target.value] = true
        },

        // show desktop settings
        switchDevice(event) {

            // remove active class from possible elements
            const icons = document.querySelectorAll('.device-selector--mini i');
            icons.forEach(icon => {
                icon.classList.remove('active')
            })
            
            // add active class to current
            event.target.classList.add('active');

            // set devices to false
            this.desktopSettings = false
            this.tabletSettings = false
            this.mobileSettings = false

            console.log(event.target.dataset.device)

            // set active settings to true
            this[event.target.dataset.device] = true

            if(event.target.dataset.device === 'tabletSettings') {
                this.$store.state.previewBoxWidth = '768px'
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.tabletStyles = true
            } else if (event.target.dataset.device === 'mobileSettings') {
                this.$store.state.previewBoxWidth = '576px'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = true
            } else {
                this.$store.state.previewBoxWidth = '100%'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = false
            }

        }

    }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/HorizontalDividerSettings.vue